import createBrowserHistory from 'history/createBrowserHistory'
import { ConnectedRouter, routerReducer, routerMiddleware, push } from 'react-router-redux'

export const history = createBrowserHistory();
export const middleware = routerMiddleware(history);



// WEBPACK FOOTER //
// ./src/components/history.js